import { render, staticRenderFns } from "./wxOfficialSubstitute.vue?vue&type=template&id=21f6aca6&scoped=true&"
import script from "./wxOfficialSubstitute.vue?vue&type=script&lang=js&"
export * from "./wxOfficialSubstitute.vue?vue&type=script&lang=js&"
import style0 from "./wxOfficialSubstitute.vue?vue&type=style&index=0&id=21f6aca6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f6aca6",
  null
  
)

export default component.exports